import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { UtilsService } from '../utils/utils.service';


@Injectable({
	providedIn: 'root',
})
export class UtilsEndPoints {
	constructor(private http: HttpClient, private utils: UtilsService ) {}

	getAllTypes(){
		const url = `${environment.api}utilidades/get_all_types`;
		return this.http.get(url);
	}

	// TODO: REVISAR PORQUE CAMBIAR NOMBRE? 
	CAMBIARNOMBREaddContractClient(payload){
		const url = `${environment.api}user/add_contract_client`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}
}
